// src/components/Chat/EmojiPicker.jsx
import React from "react";
import styles from "../Chat.module.css";

const emojiList = [
  // Yüzler ve ifadeler
  "😀","😃","😄","😁","😆","😅","😂","🤣","🥲","☺️","😊","😇","🙂","🙃","😉",
  "😌","😍","🥰","😘","😗","😙","😚","😋","😛","😝","🤪","😜","🤨","🫤","😐",
  "😑","😶","😶‍🌫️","😏","😒","🙄","😬","🤥","😌","😔","😪","🤤","😴","😷",
  "🤒","🤕","🤢","🤮","🤧","🥵","🥶","🥴","😵","😵‍💫","🤯","🤠","🥳","😎",
  "🤓","🧐","😕","😟","🙁","☹️","😮","😯","😲","😳","🥺","😦","😧","😨","😰",
  "😥","😢","😭","😱","😖","😣","😞","😓","😩","😫","🥱","😤","😡","😠","🤬",
  "😈","👿","💀","☠️","💩","🤡","👹","👺","👻","👽","👾","🤖","😺","😸","😹",
  "😻","😼","😽","🙀","😿","😾",

  // El ve hareketler
  "👋","🤚","🖐️","✋","🖖","👌","🤌","🤏","✌️","🤞","🤟","🤘","🤙","👈","👉","👆","🖕","👇",
  "☝️","👍","👎","✊","👊","🤛","🤜","👏","🙌","👐","🤲","🙏","✍️","💅","🤳","💪","🦾","🦵","🦶",

  // İnsanlar ve meslekler
  "👶","🧒","👦","👧","🧑","👨","👩","👴","👵","🧓",
  "🙍‍♂️","🙍‍♀️","🙎‍♂️","🙎‍♀️","🙅‍♂️","🙅‍♀️","🙆‍♂️","🙆‍♀️","💁‍♂️","💁‍♀️","🙋‍♂️","🙋‍♀️","🧏‍♂️","🧏‍♀️",
  "🤦‍♂️","🤦‍♀️","🤷‍♂️","🤷‍♀️","🧑‍⚕️","👨‍⚕️","👩‍⚕️","🧑‍🎓","👨‍🎓","👩‍🎓","🧑‍🏫","👨‍🏫","👩‍🏫",
  "🧑‍⚖️","👨‍⚖️","👩‍⚖️","🧑‍🌾","👨‍🌾","👩‍🌾","🧑‍🍳","👨‍🍳","👩‍🍳","🧑‍🔧","👨‍🔧","👩‍🔧",
  "🧑‍🏭","👨‍🏭","👩‍🏭","🧑‍💼","👨‍💼","👩‍💼","🧑‍🔬","👨‍🔬","👩‍🔬","🧑‍💻","👨‍💻","👩‍💻","🧑‍🎤","👨‍🎤","👩‍🎤",
  "🧑‍🎨","👨‍🎨","👩‍🎨","🧑‍✈️","👨‍✈️","👩‍✈️","🧑‍🚀","👨‍🚀","👩‍🚀","🧑‍🚒","👨‍🚒","👩‍🚒",
  "👮‍♂️","👮‍♀️","🕵️‍♂️","🕵️‍♀️","💂‍♂️","💂‍♀️","🥷","👷‍♂️","👷‍♀️","👑","👸","🤴","👰‍♀️","🤵‍♂️","🤰","🤱","🧑‍🍼",

  // Hayvanlar ve doğa
  "🐶","🐱","🐭","🐹","🐰","🦊","🐻","🐼","🐨","🐯","🦁","🐮","🐷","🐽","🐸","🐵",
  "🙈","🙉","🙊","🐒","🐔","🐧","🐦","🐤","🐣","🐥","🦆","🦅","🦉","🦇","🐺","🐗",
  "🐴","🦄","🐝","🐛","🦋","🐌","🐞","🐜","🪲","🪳","🕷️","🦂","🐢","🐍","🦎","🦖","🦕","🐙","🦑","🦐","🦞","🦀",

  // Yemek ve içecek
  "🍏","🍎","🍐","🍊","🍋","🍌","🍉","🍇","🍓","🫐","🍈","🍒","🍑","🥭","🍍","🥥",
  "🥝","🍅","🥑","🍆","🥔","🥕","🌽","🌶️","🫑","🥒","🥬","🥦","🧄","🧅","🍄","🥜","🌰","🫛","🍞","🥐","🥖","🥨","🧇","🥞","🧀","🍖","🍗","🥩","🥓","🍔","🍟","🍕","🌭","🥪","🌮","🌯","🫔","🥗","🥙","🧆","🥘","🍲","🍛","🍣","🍱","🥟","🫕","🍤","🍙","🍚","🍘","🍥","🥠","🍦","🍧","🍨","🍩","🍪","🎂","🍰","🧁","🍫","🍬","🍭","🍮","🍯","🍼","🥛","☕","🍵","🫖","🥤","🧃","🧉","🍶","🍺","🍻","🥂","🍷","🥃","🍸","🍹","🧊","🥄","🍴","🥢",

  // Aktivite, oyun ve seyahat
  "⚽","🏀","🏈","⚾","🥎","🎾","🏐","🏉","🥏","🎱","🏓","🏸","🥊","🥋","🥅","⛳","🪁","🏹","🎣","🤿","🥌","🛷","⛸️","🛼","🛹","🛶","🚣‍♂️","🚣‍♀️","🏄‍♂️","🏄‍♀️","🏊‍♂️","🏊‍♀️","🤽‍♂️","🤽‍♀️","🚴‍♂️","🚴‍♀️","🚵‍♂️","🚵‍♀️","🏇","🧗‍♂️","🧗‍♀️","🤸‍♂️","🤸‍♀️","⛹️‍♂️","⛹️‍♀️","🤾‍♂️","🤾‍♀️","🏋️‍♂️","🏋️‍♀️","🤺","🤼‍♂️","🤼‍♀️","🥇","🥈","🥉","🏆","🏅","🎖️","🏵️","🎗️","🎫","🎟️","🎪","🎭","🎨","🎬","🎤","🎧","🎼","🎹","🥁","🎷","🎺","🎸","🪕","🎻","🎮","🕹️","🎯","🎳","🎲","🧩","🧸","🎁","🎈","🎏","🎀","🎃","🎄","🎆","🎇","✨","🎉","🎊"
];

const EmojiPicker = ({ onSelect, isVisible }) => {
  if (!isVisible) return null;
  return (
    <div className={styles.emojiPickerPopup}>
      <div className={styles.emojiGrid}>
        {emojiList.map((emoji, index) => (
          <span
            key={index}
            className={styles.emojiItem}
            onClick={() => onSelect({ native: emoji })}
          >
            {emoji}
          </span>
        ))}
      </div>
    </div>
  );
};

export default EmojiPicker;
